suggest_an_improvement_handler = {

    properties: {
        completed: false
    },

    onLoad: function(){
        var self = this;

        if (self.properties.completed){
          window.location.href = "#/complete/";  
        }

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large secondary-bg background-img');

    },

    updateStatus: function(next){
        var statusItem = $('.survey-status-item');
        $.each(statusItem, function(index, value)
        {
            $(value).children('img').attr('src', 'img/survey-item.png');
        });
        $.each(statusItem, function(index, value)
        {
            if ($(value).attr('for') == next){
                $(value).children('img').attr('src', 'img/survey-active.png');
                return false;
            }
            $(value).children('img').attr('src', 'img/survey-complete.png');
        });
    },


    events: function() {
        var self = this;
        self.onLoad();
    }
}
